import React from "react";
import "./TopFoods.css";

const TopFoods = ({ foods }) => {
  return (
    <div className="top-foods">

      <div className="top-foods-header">
        <h2>🍽️ Top Selling Foods</h2>
        <p>Best performing menu items</p>
      </div>

      <div className="top-foods-list">

        {foods.length === 0 ? (

          <div className="top-food-empty">
            No food sales available.
          </div>

        ) : (

          foods.map((food, index) => (

            <div
              className="food-item"
              key={food._id}
            >

              <div className="food-rank">
                #{index + 1}
              </div>

              <div className="food-details">

                <h4>
                  {food.foodName || food.name}
                </h4>

                <p>
                  {food.category}
                </p>

              </div>

              <div className="food-orders">

                <span>
                  {food.totalOrders || 0}
                </span>

                <small>Orders</small>

              </div>

            </div>

          ))

        )}

      </div>

    </div>
  );
};

export default TopFoods;